import { useMutation } from "@tanstack/react-query";
import { $api } from "../generated/client";
import type { ResetPasswordRequestDto } from "../generated/schema";

export function useResetPassword() {
  const mutation = $api.useMutation("post", "/auth/reset-password");

  return useMutation({
    mutationFn: async (data: ResetPasswordRequestDto) => {
      return mutation.mutateAsync({
        body: data,
        headers: {
          "x-auth-request": "true",
        },
      });
    },
  });
}
